window.customElements.define('modemmate-services', class extends HTMLElement {

  productForm = undefined;
  assemblyChecked = false;
  assemblyServiceId = undefined;
  STORAGE_PREFIX = 'assembly_service_';
  ZIP_OUT_OF_AREA_MSG = "We're sorry! Our assembly team hasn't reached your area yet. We're working hard to expand our coverage.";

  getServiceSelection(service) {
    if (!service) return null;
    return {
      variantId: service.getAttribute('data-service-id'),
      providerCode: service.getAttribute('data-service-provider-code') || '',
      providerName: service.getAttribute('data-service-provider') || '',
      offeringCode: service.getAttribute('data-service-offering-code') || '',
      offeringName: service.getAttribute('data-service-offering-name') || '',
      offeringId: service.getAttribute('data-service-offering-id') || '',
    };
  }

  persistSelection(relatedId, selection) {
    if (!relatedId || !selection?.variantId) return;
    window.sessionStorage.setItem(this.STORAGE_PREFIX + relatedId, JSON.stringify(selection));
  }

  constructor() {
    super();
    this.services = this.querySelectorAll('.product-services__item');
    this.variantId = this.getAttribute('data-variant-id');
    this.zeroPriceService = Array.from(this.services).find(service => {
      const price = Number(service.getAttribute('data-service-price'));
      return price === 0;
    });
    this.initZipModal();

    // 默认去掉当前变体缓存
    if (this.variantId) {
      window.sessionStorage.removeItem(this.STORAGE_PREFIX + this.variantId);
    }

    // 默认仅选择价格为 0 的服务，若不存在则不默认选中任何项
    if (this.zeroPriceService) {
      this.selectService(this.zeroPriceService, this.variantId);
    }

    this.services.forEach(service => {
      const radio = service.querySelector('.product-services__icon');
      const detailsLink = service.querySelector('.product-services__details-link');

      // 处理详情链接点击事件
      if (detailsLink) {
        detailsLink.addEventListener('click', (e) => {
          e.stopPropagation(); // 阻止事件冒泡，避免触发服务选择
          const serviceId = detailsLink.getAttribute('data-service-id');
          const detailsDiv = service.querySelector(`.product-services__details[data-service-id="${serviceId}"]`);
          if (detailsDiv) {
            const content = detailsDiv.innerHTML;
            this.openDetailsModal(content);
          }
        });
      }

      service.addEventListener('click', () => {
        const params = new URLSearchParams(window.location.search);
        const relatedId = params.get('variant') || this.variantId;

        // 当前 service 的配置信息
        const selection = this.getServiceSelection(service);

        const isAlreadyChecked = radio && radio.checked;

        if (isAlreadyChecked) {
          // 当前项已选中：若存在 0 价服务，则强制保持 0 价服务为选中；否则允许取消
          if (this.zeroPriceService) {
            this.selectService(this.zeroPriceService, relatedId);
          } else {
            this.clearSelection(relatedId);
          }
        } else if (this.hasZipcodeList(service)) {
          // 需校验邮编后才允许选中
          this.promptZipAndValidate(service).then((isValid) => {
            if (isValid) {
              this.selectService(service, relatedId, selection);
            }
          });
        } else {
          // 选中当前项并写入缓存
          this.selectService(service, relatedId, selection);
        }
      });
    });
  }

  clearServiceSelectionUI() {
    this.services.forEach(s => {
      const r = s.querySelector('.product-services__icon');
      if (r) {
        r.checked = false;
      }
      s.classList.remove('product-services__item--selected');
    });
  }

  selectService(service, relatedId, selection) {
    this.clearServiceSelectionUI();

    const radio = service ? service.querySelector('.product-services__icon') : null;
    const resolvedSelection = selection || this.getServiceSelection(service);

    if (radio) {
      radio.checked = true;
    }
    if (service) {
      service.classList.add('product-services__item--selected');
    }

    this.assemblyChecked = !!resolvedSelection?.variantId;
    this.assemblyServiceId = resolvedSelection?.variantId;
    this.assemblySelection = resolvedSelection;
    this.persistSelection(relatedId, resolvedSelection);
  }

  clearSelection(relatedId) {
    this.clearServiceSelectionUI();
    this.assemblyChecked = false;
    this.assemblyServiceId = undefined;
    this.assemblySelection = undefined;
    window.sessionStorage.removeItem(this.STORAGE_PREFIX + relatedId);
  }


  updateRelatedServiceInfo(variantId) {
    this.productForm = document.querySelector('product-form');

    if (this.assemblyChecked && this.assemblySelection) {
      this.persistSelection(variantId, this.assemblySelection);
    } else {
      window.sessionStorage.removeItem(this.STORAGE_PREFIX + variantId);
    }
  }

  openDetailsModal(content) {
    const drawer = document.querySelector('product-services-details-drawer');
    const contentDiv = drawer ? drawer.querySelector('.product-services-details-drawer__content') : null;

    if (!drawer || !contentDiv) return;

    // 设置内容（直接使用 innerHTML，因为内容可能包含 HTML）
    contentDiv.innerHTML = content;

    // 打开 drawer
    drawer.open();
  }

  /** 初始化邮编弹窗 */
  initZipModal() {
    const root = document.getElementById('product-services');
    this.zipModal = root ? root.querySelector('#product-services-zip-modal') : null;
    this.zipInput = document.getElementById('product-services-zip-input');
    this.zipSuggestions = document.getElementById('product-services-zip-suggestions');
    this.zipError = document.getElementById('product-services-zip-error');
    this.zipSubmit = document.getElementById('product-services-zip-submit');
    this.zipModalResolve = null;
    this.zipModalService = null;
    this.zipSuggestionIndex = -1;
    this.ZIP_SUGGESTION_LIMIT = 10;

    if (!this.zipModal || !this.zipInput || !this.zipSubmit) return;

    // 挂到 body，避免父级 transform/overflow 导致 fixed 定位无法相对视口居中
    if (this.zipModal.parentElement !== document.body) {
      document.body.appendChild(this.zipModal);
    }

    this.zipModal.querySelectorAll('[data-zip-modal-close]').forEach((el) => {
      el.addEventListener('click', () => this.closeZipModal(false));
    });

    this.zipSubmit.addEventListener('click', () => this.handleZipSubmit());

    this.zipInput.addEventListener('input', () => {
      this.hideZipError();
      this.updateZipSuggestions();
    });

    this.zipInput.addEventListener('focus', () => {
      this.updateZipSuggestions();
    });

    this.zipInput.addEventListener('keydown', (evt) => {
      this.handleZipInputKeydown(evt);
    });

    this.zipModal.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') {
        if (this.zipSuggestions && !this.zipSuggestions.hidden) {
          this.hideZipSuggestions();
          return;
        }
        this.closeZipModal(false);
      }
    });

    document.addEventListener('click', (evt) => {
      if (!this.zipModal || !this.zipModal.classList.contains('product-services-zip-modal--active')) return;
      if (!evt.target.closest('.product-services-zip-modal__field')) {
        this.hideZipSuggestions();
      }
    });
  }

  /** 解析 data-zipcode-list 为邮编数组 */
  parseZipcodeList(raw) {
    if (!raw || !String(raw).trim()) return null;

    try {
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed) || parsed.length === 0) return null;
      return parsed.map((zip) => String(zip).trim());
    } catch (e) {
      return null;
    }
  }

  /** 是否配置了邮编白名单 */
  hasZipcodeList(service) {
    return this.parseZipcodeList(service.getAttribute('data-zipcode-list')) !== null;
  }

  /** 标准化用户输入的邮编（取前 5 位数字） */
  normalizeZip(zip) {
    const digits = String(zip).trim().replace(/\D/g, '');
    return digits.slice(0, 5);
  }

  /** 校验邮编是否在白名单内 */
  isZipInList(zip, zipList) {
    const normalized = this.normalizeZip(zip);
    if (!normalized) return false;
    return zipList.some((item) => this.normalizeZip(item) === normalized);
  }

  /** 根据输入前缀从白名单中筛选邮编 */
  getZipSuggestionMatches(query, zipList) {
    if (!query || !zipList) return [];

    const seen = new Set();
    const matches = [];

    zipList.forEach((zip) => {
      const normalized = this.normalizeZip(zip);
      if (!normalized || !normalized.startsWith(query) || seen.has(normalized)) return;
      seen.add(normalized);
      matches.push(normalized);
    });

    return matches.sort().slice(0, this.ZIP_SUGGESTION_LIMIT);
  }

  /** 渲染邮编联想下拉 */
  renderZipSuggestions(items) {
    if (!this.zipSuggestions) return;

    this.zipSuggestions.innerHTML = '';
    this.zipSuggestionIndex = -1;

    if (!items.length) {
      this.hideZipSuggestions();
      return;
    }

    items.forEach((zip) => {
      const item = document.createElement('li');
      item.className = 'product-services-zip-modal__suggestion-item';
      item.setAttribute('role', 'option');
      item.setAttribute('data-zip', zip);
      item.textContent = zip;
      item.addEventListener('mousedown', (evt) => evt.preventDefault());
      item.addEventListener('click', () => this.selectZipSuggestion(zip));
      this.zipSuggestions.appendChild(item);
    });

    this.zipSuggestions.hidden = false;
    this.zipInput.setAttribute('aria-expanded', 'true');
  }

  /** 更新邮编联想下拉 */
  updateZipSuggestions() {
    if (!this.zipInput || !this.zipModalService) {
      this.hideZipSuggestions();
      return;
    }

    const zipList = this.parseZipcodeList(this.zipModalService.getAttribute('data-zipcode-list'));
    const query = this.normalizeZip(this.zipInput.value);
    const matches = this.getZipSuggestionMatches(query, zipList);

    this.renderZipSuggestions(matches);
  }

  /** 选中联想项 */
  selectZipSuggestion(zip) {
    if (!this.zipInput) return;
    this.zipInput.value = zip;
    this.hideZipSuggestions();
    this.hideZipError();
    this.zipInput.focus();
  }

  hideZipSuggestions() {
    if (!this.zipSuggestions) return;
    this.zipSuggestions.innerHTML = '';
    this.zipSuggestions.hidden = true;
    this.zipSuggestionIndex = -1;
    if (this.zipInput) {
      this.zipInput.setAttribute('aria-expanded', 'false');
    }
  }

  /** 键盘操作联想下拉 */
  handleZipInputKeydown(evt) {
    const items = this.zipSuggestions
      ? this.zipSuggestions.querySelectorAll('.product-services-zip-modal__suggestion-item')
      : [];

    if (!this.zipSuggestions || this.zipSuggestions.hidden || !items.length) {
      if (evt.key === 'Enter') {
        evt.preventDefault();
        this.handleZipSubmit();
      }
      return;
    }

    if (evt.key === 'ArrowDown') {
      evt.preventDefault();
      this.zipSuggestionIndex = Math.min(this.zipSuggestionIndex + 1, items.length - 1);
      this.setActiveZipSuggestion(items);
      return;
    }

    if (evt.key === 'ArrowUp') {
      evt.preventDefault();
      this.zipSuggestionIndex = Math.max(this.zipSuggestionIndex - 1, 0);
      this.setActiveZipSuggestion(items);
      return;
    }

    if (evt.key === 'Enter') {
      evt.preventDefault();
      if (this.zipSuggestionIndex >= 0 && items[this.zipSuggestionIndex]) {
        this.selectZipSuggestion(items[this.zipSuggestionIndex].getAttribute('data-zip'));
        return;
      }
      this.handleZipSubmit();
    }
  }

  setActiveZipSuggestion(items) {
    items.forEach((item, index) => {
      item.classList.toggle('product-services-zip-modal__suggestion-item--active', index === this.zipSuggestionIndex);
    });
    if (this.zipSuggestionIndex >= 0 && items[this.zipSuggestionIndex]) {
      items[this.zipSuggestionIndex].scrollIntoView({ block: 'nearest' });
    }
  }

  /** 打开邮编弹窗并等待校验结果 */
  promptZipAndValidate(service) {
    if (!this.zipModal) return Promise.resolve(true);

    return new Promise((resolve) => {
      this.zipModalResolve = resolve;
      this.zipModalService = service;
      this.zipInput.value = '';
      this.hideZipError();
      this.hideZipSuggestions();
      this.zipModal.classList.add('product-services-zip-modal--active');
      this.zipModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      this.zipInput.focus();
    });
  }

  /** 处理邮编提交 */
  handleZipSubmit() {
    if (!this.zipModalService) {
      this.closeZipModal(false);
      return;
    }

    const zipList = this.parseZipcodeList(this.zipModalService.getAttribute('data-zipcode-list'));
    const zipValue = this.zipInput ? this.zipInput.value : '';

    if (!zipValue.trim()) {
      this.showZipError('Enter ZIP for assembly options.');
      return;
    }

    if (!zipList || !this.isZipInList(zipValue, zipList)) {
      this.showZipError(this.ZIP_OUT_OF_AREA_MSG);
      return;
    }

    this.closeZipModal(true);
  }

  showZipError(message) {
    if (!this.zipError) return;
    this.zipError.textContent = message;
    this.zipError.hidden = false;
  }

  hideZipError() {
    if (!this.zipError) return;
    this.zipError.textContent = '';
    this.zipError.hidden = true;
  }

  closeZipModal(isValid) {
    this.hideZipSuggestions();
    if (this.zipModal) {
      this.zipModal.classList.remove('product-services-zip-modal--active');
      this.zipModal.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('overflow-hidden');

    const resolve = this.zipModalResolve;
    this.zipModalResolve = null;
    this.zipModalService = null;

    if (resolve) {
      resolve(!!isValid);
    }
  }
});
